export const downloadFile = (url: string, name?: string) => {
    fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
            const blobUrl = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = blobUrl
            link.download = name || 'download'
            document.body.appendChild(link)
            link.click()
            setTimeout(() => {
                URL.revokeObjectURL(blobUrl)
                link.parentNode?.removeChild(link)
            }, 100)
        })
        .catch(() => {
            // as fallback just open url in new tab
            window.open(url, '_blank')
        })
}
